

export class EnquiryReportFilterDto{
    enquiryNumber?:string;
    fromDate?:string;
    toDate?:string;
    countryId?:number;
    skuCodeId?:number
    buyerId?:number;
    agentId?:number;
    salesPersonId?:number;
 
    
    constructor( enquiryNumber?:string,fromDate?:string,
        toDate?:string ,countryId?:number,skuCodeId?:number,buyerId?:number,
        agentId?:number,
        salesPersonId?:number,){
        this.enquiryNumber = enquiryNumber;
        this.fromDate=fromDate;
        this.toDate=toDate
        this.countryId = countryId;
        this.skuCodeId = skuCodeId;
        this.buyerId = buyerId;
        this.agentId = agentId;
        this.salesPersonId = salesPersonId;
    }
}
